import { render, staticRenderFns } from "./dashboard-chart.vue?vue&type=template&id=7a06886a&scoped=true&"
import script from "./dashboard-chart.vue?vue&type=script&lang=js&"
export * from "./dashboard-chart.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-chart.vue?vue&type=style&index=0&id=7a06886a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a06886a",
  null
  
)

export default component.exports